import type { FaireProductEntity } from "../../entity_types/product";

export const p_e9jmsxryu7: FaireProductEntity = {
  token: "p_e9jmsxryu7",
  type: "product",
  name: "Yellow Daisies - Organic Cotton Jacquard Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d4aaecb90a97933c19bfbfe1bd7c526ed4c8b137b07ed33dbf75751a311d0b63.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0352b709f500f6dca2c6b7248517155ed824e3f7e0a78a47cdd32a1efd2bc49d.png",
    "https://cdn.faire.com/fastly/2ca5802c04625e976a194bb6a492b3baa77ddb4d6eb1fc5060bf649b772e8f45.png",
    "https://cdn.faire.com/fastly/9277e99423a5469ebd181dbf95a8889b09651935d369e9374ad1c61c90679fbb.png",
    "https://cdn.faire.com/fastly/591afac13864e11cd3635ba1e1e1487d06b2db60b5403dec049d6076169f13ef.png",
  ],
  priceDollars: 26,
  description:
    "Organic Cotton Jacquard Baby Blanket – Daisy Motif\n\nInspired by the calm rhythm of the ocean, this 100% organic cotton jacquard baby blanket features a beautifully textured knit with sweet daisy motifs.\n\nThe breathable jacquard construction offers a soft, lightweight, and cozy feel, making it perfect for all seasons. Gentle on delicate skin and free from harmful chemicals, it delivers natural comfort parents can trust.\n\nMade from sustainably grown organic cotton, this blanket supports better livelihoods for small grower farmers and reflects a commitment to responsible craftsmanship. Designed in the USA and ethically made by skilled artisans in India at a GOTS-certified facility, every piece is created with care and intention.\n\nIdeal for nursery decor, stroller rides, and quiet cuddle moments—this blanket brings a touch of the sea to everyday comfort.\n\nPure comfort, by Viverano.",
  tags: [],
  msrpDollars: 52,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T19:56:51.548Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
